/**
 * Resolve the additional-instructions value to send when generating a meeting note.
 * Returns undefined for templates that are not eligible for summarisation (those
 * suppress instructions entirely) or when the box is empty. Defaults to eligible
 * when the flag is absent, matching the backend default.
 */
export function resolveAdditionalInstructions(
  eligibleForSummarisation: boolean | undefined,
  value: string | undefined,
): string | undefined {
  if (!(eligibleForSummarisation ?? true)) {
    return undefined;
  }
  return value?.trim() || undefined;
}
